export default __webpack_public_path__ + "static/media/icon_mina.09faa086.svg";